import { H2, HStack } from '@montel/montelpro-shared-components-v2';
import { ProductIcon } from '../ProductIcon/ProductIcon';
import { FunctionComponent } from 'react';
import { ProductName } from 'domain/product/enums';
import { getProductConfigByName } from 'domain/product/productMap';

const PageHeading: FunctionComponent<{ product: ProductName }> = ({
	product,
}) => {
	const config = getProductConfigByName(product);

	return (
		<HStack align="center">
			{config ? (
				<ProductIcon productId={config.id} withTooltip={false} />
			) : null}
			<H2 as={'h1'}>{config?.name}</H2>
		</HStack>
	);
};

export default PageHeading;
